export const IMG = (f) => `/img/${f}.webp`;

export const CONTACT = {
  phones: [
    { label: "+91 98509 95074", tel: "+919850995074" },
  ],
  emails: ["sales.muplast@outlook.com", "muplast@outlook.com"],
  whatsapp: "https://wa.me/919850995074",
  address: ["Plot no A-82, MIDC, Shrirampur,", "District Ahilyanagar, Maharashtra", "India — 413709"],
  mapQuery: "MU Plast Pvt Ltd, Plot A-82, MIDC Shrirampur, Maharashtra 413709",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/technology-quality", label: "Technology & Quality" },
  { to: "/sustainability", label: "Sustainability" },
  { to: "/contact", label: "Contact" },
];

export const CERTS = [
  { code: "ISO 9001:2015", name: "Quality Management System", resource: "iso-9001-certificate" },
  { code: "FSSC 22000", name: "Food Safety System Certification", resource: "fssc-22000-certificate" },
];

export const STATS = [
  { value: "1B+", label: "Closures produced annually" },
  { value: "2", label: "Product families" },
  { value: "Certified", label: "ISO 9001:2015 & FSSC 22000" },
  { value: "2022", label: "Year established" },
];

export const APART = [
  { img: "photos_caps_alaska_DSC09606", title: "Colour & customisation", body: "Custom designs, embossing and an extensive colour range let brands build packaging that stands out on shelf." },
  { img: "photos_preforms_alaska_DSC09824", title: "Neck sizes & formats", body: "Alaska 27mm and 26/22 short neck finishes, spanning fifteen grammages across 500 ml and 1000 ml programmes." },
  { img: "photos_caps_alaska_DSC09549", title: "Consistency at scale", body: "Material excellence and dimensional accuracy, supported by efficient production that reduces material waste." },
];

const c = (dir, list) => list.map(([hex, n, name]) => ({ hex, img: `caps/${dir}_${n}`, name }));
const ALASKA = c("alaska", [["#181b1a", "09490"], ["#192d3c", "09556"], ["#392157", "09549"], ["#1b3993", "09544"], ["#702958", "09522"], ["#264d4f", "09562"], ["#86432c", "09448"], ["#8c3872", "09520"], ["#af1928", "09460"], ["#bc2370", "09595"], ["#096ecf", "09508"], ["#0a7e85", "09474"], ["#967634", "09539"], ["#138bed", "09502"], ["#a88946", "09537"], ["#58a309", "09477"], ["#f96214", "09525", "Orange"], ["#29a2b2", "09580", "G Green"], ["#2ea1e9", "09584", "Sky Blue"], ["#ddac02", "09458"], ["#bcc7c6", "09491", "White"]]);
const W15 = c("shortneck-w15", [["#212a2a", "09648"], ["#362257", "09663"], ["#264044", "09668"], ["#b6216c", "09660"], ["#0b70d2", "09678"], ["#2d95dd", "09676", "Sky Blue"], ["#20a293", "09657", "G Green"], ["#66bd1a", "09643"], ["#43b6f6", "09672"], ["#d4a801", "09694"], ["#c0c5c0", "09683", "White"]]);
const W18 = c("shortneck-w18", [["#1b3b94", "09699"], ["#2b4e52", "09710"], ["#505a7d", "09743"], ["#b51d2e", "09702"], ["#dd358f", "09713"], ["#17909c", "09722", "G Green"], ["#359fe4", "09725", "Sky Blue"], ["#2bb2bd", "09720"], ["#28b8a5", "09730", "Teal"], ["#d4a601", "09694"], ["#bdc2be", "09736", "White"]]);

export const CLOSURES = [
  {
    id: "w18",
    name: "Closure short neck W18",
    short: "Closure short neck W18",
    tag: "26/22 short neck",
    img: "photos_caps_shortneck-w18_DSC09700",
    blurb: "Stylish W18 closures combining a premium appearance with strong sealing performance.",
    highlights: ["Premium look and strong seal", "Consistent performance on bottling lines"],
    features: ["Tamper-evident bands", "Custom colours to client specification", "Lightweight, recyclable designs", "11 colour options"],
    colours: W18,
    neck: "26/22 Shortneck",
    specs: [["Neck finish", "26/22 short neck (W18)"], ["Type", "Tamper-evident band"], ["Material", "Food-grade, lightweight, recyclable design"], ["Colour options", "11 standard colours, custom to client specification"], ["Application", "Packaged drinking water and beverages"], ["Technology", "SACMI compression moulding"]],
  },
  {
    id: "w15",
    name: "Closure short neck W15",
    short: "Closure short neck W15",
    tag: "26/22 short neck",
    img: "photos_caps_shortneck-w15_DSC09679",
    blurb: "Sleek W15 short neck closures offering modern design with reliable sealing performance.",
    highlights: ["Modern profile for short neck programs", "Reliable sealing performance"],
    features: ["Tamper-evident bands", "Custom colours to client specification", "Lightweight, recyclable designs", "11 colour options"],
    colours: W15,
    neck: "26/22 Shortneck",
    specs: [["Neck finish", "26/22 short neck (W15)"], ["Type", "Tamper-evident band"], ["Material", "Food-grade, lightweight, recyclable design"], ["Colour options", "11 standard colours, custom to client specification"], ["Application", "Packaged drinking water and beverages"], ["Technology", "SACMI compression moulding"]],
  },
  {
    id: "alaska",
    name: "Closure Alaska",
    short: "Closure Alaska",
    tag: "Tamper-evident",
    img: "photos_caps_alaska_DSC09544",
    blurb: "Reliable Alaska Closures built for secure fit and consistent bottling efficiency.",
    highlights: ["Secure fit and line-ready sealing", "Multiple colour options available"],
    features: ["100% virgin food-grade raw materials", "Embossing and colour customisation", "Custom printing and logo integration", "21 colour options"],
    colours: ALASKA,
    neck: "Alaska 27mm",
    specs: [["Neck finish", "Alaska 27mm"], ["Type", "Tamper-evident closure"], ["Material", "100% virgin food-grade raw materials"], ["Colour options", "21 standard colours, custom on request"], ["Customisation", "Embossing, custom printing and logo integration"], ["Application", "Packaged drinking water and beverages"], ["Technology", "SACMI compression moulding"]],
  },
];

const PHOTOS = ["photos_preforms_alaska_DSC09848", "photos_preforms_alaska_DSC09824", "photos_preforms_alaska_DSC09848-cutout"];
const PREFORM_BASE = {
  img: "photos_preforms_alaska_DSC09848",
  photos: PHOTOS,
};

export const PREFORMS = [
  {
    ...PREFORM_BASE,
    id: "preform-shortneck",
    name: "Preform 26/22",
    short: "Preform 26/22",
    tag: "26/22 Shortneck",
    img: "photos_preforms_alaska_DSC09824",
    photos: [PHOTOS[1], PHOTOS[0], PHOTOS[2]],
    blurb: "Lightweight 26/22 short neck PET preforms—dimensionally accurate and engineered for strength, clarity, and reliable performance on high-speed bottling lines.",
    highlights: ["26/22 short neck finish", "7 grammages for 500 ml & 1000 ml"],
    features: ["26/22 short neck finish", "Seven grammages from 9.9g to 17.8g", "For 500 ml and 1000 ml applications", "Supplied in 25 kg bags", "Advanced hot runner technology for strength and clarity"],
    specs: [["Neck finish", "26/22 Shortneck"], ["Applications", "500 ml and 1000 ml"], ["Grammage range", "9.9g – 17.8g (7 variants)"], ["Packing", "25 kg bags"], ["Technology", "Hot runner moulding"], ["Matching closure", "Short neck closures W15 & W18"]],
    bag: "25 kg",
    rows: [
      ["26/22 Shortneck", "500ml", "9.9g"], ["26/22 Shortneck", "500ml", "10.4g"], ["26/22 Shortneck", "500ml", "11g"],
      ["26/22 Shortneck", "1000ml", "16.4g"], ["26/22 Shortneck", "1000ml", "16.9g"], ["26/22 Shortneck", "1000ml", "17.2g"], ["26/22 Shortneck", "1000ml", "17.8g"],
    ],
  },
  {
    ...PREFORM_BASE,
    id: "preform-alaska",
    name: "Preform Alaska",
    short: "Preform Alaska",
    tag: "Alaska 27mm",
    blurb: "Durable, dimensionally accurate PET preforms with Alaska 27mm neck finish—engineered for strength, clarity, and reliable performance on high-speed bottling lines.",
    highlights: ["Alaska 27mm neck finish", "8 grammages for 500 ml & 1000 ml"],
    features: ["Alaska 27mm neck finish", "Eight grammages from 10g to 19.5g", "For 500 ml and 1000 ml applications", "Supplied in 20 kg bags", "Advanced hot runner technology for strength and clarity"],
    specs: [["Neck finish", "Alaska 27mm"], ["Applications", "500 ml and 1000 ml"], ["Grammage range", "10g – 19.5g (8 variants)"], ["Packing", "20 kg bags"], ["Technology", "Hot runner moulding"], ["Matching closure", "Alaska 27mm closures"]],
    bag: "20 kg",
    rows: [
      ["Alaska 27mm", "500ml", "10g"], ["Alaska 27mm", "500ml", "12.5g"], ["Alaska 27mm", "500ml", "13g"], ["Alaska 27mm", "500ml", "13.5g"],
      ["Alaska 27mm", "1000ml", "18g"], ["Alaska 27mm", "1000ml", "18.5g"], ["Alaska 27mm", "1000ml", "19g"], ["Alaska 27mm", "1000ml", "19.5g"],
    ],
  },
];

export const GALLERY = [
  { img: "about_facilities_manufacturing-lines", title: "Manufacturing lines" },
  { img: "about_gallery-operations", title: "Operations" },
  { img: "about_gallery-quality-process", title: "Quality and process" },
  { img: "about_gallery-production-floor", title: "Production floor" },
  { img: "about_gallery-facility-overview", title: "Facility overview" },
  { img: "about_gallery-material-handling", title: "Material handling, storage and dispatch" },
];

export const PRODUCTS = [...CLOSURES, ...PREFORMS];
export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);
export const BROCHURE_URL = "/downloads/mu-plast-company-brochure.pdf";
